import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
export const CustomToastContainer = styled(ToastContainer).withConfig({
  componentId: "sc-hknt6g-0"
})(["display:flex;flex-direction:column;align-items:center;margin-top:3rem;.Toastify__toast{width:fit-content;height:3rem;padding:0.75rem 1rem;background:var(--gray-100);border-radius:0.5rem;box-shadow:0px 4px 16px 0px rgba(25,32,41,0.16);.Toastify__toast-body{", " >div:nth-child(2){", " .snack-bar{", " > div:first-child{", "}> div:nth-child(2){> div{", "}}}}}.Toastify__close-button{display:none;}}"], {
  "margin": "0px",
  "padding": "0px"
}, {
  "whiteSpace": "nowrap",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(54 65 82 / var(--tw-text-opacity, 1))"
}, {
  "display": "flex",
  "alignItems": "center",
  "gap": "1rem"
}, {
  "whiteSpace": "nowrap",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(54 65 82 / var(--tw-text-opacity, 1))"
}, {
  "cursor": "pointer",
  "whiteSpace": "nowrap",
  "fontSize": "0.75rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(62 126 254 / var(--tw-text-opacity, 1))"
});
export const NotifyUpdateToastStyle = styled.button.withConfig({
  componentId: "sc-hknt6g-1"
})(["@keyframes move{0%{transform:translate(-50%,-200px);display:none;}85%{transform:translate(-50%,10px);display:flex;}95%{transform:translate(-50%,5px);display:flex;}100%{transform:translate(-50%,0);display:flex;}}&{", " box-shadow:0px 4px 16px 0px rgba(25,32,41,0.16);top:calc(var(--height-global-nav) + 0.5rem);left:50%;transform:translateX(-50%);animation-name:move;animation-duration:0.5s;}"], {
  "position": "fixed",
  "zIndex": "100",
  "display": "flex",
  "width": "fit-content",
  "cursor": "pointer",
  "alignItems": "center",
  "gap": "0.5rem",
  "borderRadius": "1.25rem",
  "borderWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(32 41 57 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "600",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))",
  "&:hover": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(238 242 246 / var(--tw-bg-opacity, 1))"
  },
  "&:active": {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(238 242 246 / var(--tw-bg-opacity, 1))"
  }
});